"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgGrimacingFaceFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M16 13.5H8a.5.5 0 00-.5.5v.5h9V14a.5.5 0 00-.5-.5zM7.5 16a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-.5h-9v.5z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM8 12a2 2 0 00-2 2v2a2 2 0 002 2h8a2 2 0 002-2v-2a2 2 0 00-2-2H8zm-.5 2a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v.5h-9V14zm.5 2.5a.5.5 0 01-.5-.5v-.5h9v.5a.5.5 0 01-.5.5H8zM10 9a1 1 0 11-2 0 1 1 0 012 0zm5 1a1 1 0 100-2 1 1 0 000 2z' }))); };
exports.default = SvgGrimacingFaceFilled;
//# sourceMappingURL=GrimacingFaceFilled.js.map